// Sağ panel — aktif bölümün açık tutarlılık bulguları (ilk 5 + "tümü (n)").
import { fillTemplate } from "../../lib/period-ui";
import { REPORT_CHECK_COPY } from "../../lib/report-check-copy";
import { useReportCheckStore } from "../../stores/report-check-store";

const SHOWN = 5;

export function ReportCheckSectionBlock({
  code,
  onShowAll,
}: {
  code: string;
  onShowAll: () => void;
}): JSX.Element | null {
  const current = useReportCheckStore((s) => s.current);
  const open = (current?.findings ?? []).filter(
    (f) => f.status === "open" && f.sectionCodes.includes(code),
  );
  if (open.length === 0) return null;
  return (
    <section className="mb-4" data-testid="report-check-section-block">
      <h3
        className="mb-2 text-xs uppercase tracking-wider"
        style={{ color: "var(--color-text-3)" }}
      >
        {REPORT_CHECK_COPY.tab}
      </h3>
      <ul className="text-xs" style={{ color: "var(--color-text-2)" }}>
        {open.slice(0, SHOWN).map((f) => (
          <li key={f.id} className="mb-1.5">
            {f.title}
          </li>
        ))}
      </ul>
      {open.length > SHOWN && (
        <button
          type="button"
          className="text-xs"
          style={{ color: "var(--color-primary)" }}
          onClick={onShowAll}
        >
          {fillTemplate(REPORT_CHECK_COPY.showAll, { n: open.length })}
        </button>
      )}
    </section>
  );
}
